import axios from 'axios';
import { LoginRequest, LoginResponse, BlogPost, AnalyticsSummary } from '../types';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://api.khudoyshukur.dev/api'
  : 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authApi = {
  login: (credentials: LoginRequest): Promise<LoginResponse> =>
    api.post('/auth/login', credentials).then(response => response.data),
  
  logout: (): Promise<void> =>
    api.post('/auth/logout').then(() => {
      localStorage.removeItem('adminToken');
    }),
  
  validateToken: (): Promise<{ valid: boolean; username?: string }> =>
    api.get('/auth/validate').then(response => response.data),
};

export const blogApi = {
  getAllPosts: (): Promise<BlogPost[]> =>
    api.get('/admin/blog').then(response => response.data),
  
  createPost: (post: BlogPost): Promise<BlogPost> =>
    api.post('/admin/blog', post).then(response => response.data),
  
  updatePost: (id: number, post: BlogPost): Promise<BlogPost> =>
    api.put(`/admin/blog/${id}`, post).then(response => response.data),
  
  deletePost: (id: number): Promise<void> =>
    api.delete(`/admin/blog/${id}`).then(() => {}),
};

export const analyticsApi = {
  getSummary: (days: number = 30): Promise<AnalyticsSummary> =>
    api.get('/admin/analytics/summary', { params: { days } }).then(response => response.data),
};

export const resumeApi = {
  refresh: (): Promise<{ fetchedAt: string }> =>
    api.post('/admin/resume/refresh').then(response => response.data),
};

